module.exports = __webpack_public_path__ + "img/OT330778.f85c8f1.webp";